import { SvgIcon, SvgIconProps } from '@mui/material';

const ArrowDropDownFilled = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="ArrowDropDownFilledIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path d="M7 9.5L12 14.5L17 9.5H7Z" />
    </SvgIcon>
  );
};

export default ArrowDropDownFilled;
